export enum LabelledCheckboxSelectionTheme {
    NONE = 'none',
    PRIMARY = 'PRIMARY'
}